import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    tab: {
        background: "white",
        color: "black",
    },
    appbar: {
        backgroundColor: "#50907D",
        boxShadow: "none",
        paddingLeft: "1em",
    },
    button: {
        background: "#f29426",
        color: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingLeft: "15px",
        paddingRight: "15px",
        height: "max-content",
        "&:hover, &:focus": {
            background: "#f27500 !important",
        },
    },
    dialog: {
        "& .MuiDialog-paper": {
            maxWidth: "700px",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`concursos-tabpanel-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}


